import {z} from 'zod';

import {fetchAndDeserialize} from '../../util/api-adapter';

import {userSchema, UserType} from './user-type';

export async function fetchUserOwn(): Promise<UserType> {
    const [userData, regionAvailableCatalogs] = await Promise.all([
        fetchAndDeserialize<Omit<UserType, 'regionAvailableCatalogs'>>(
            '/cp/user/',
            userSchema.omit({regionAvailableCatalogs: true})
        ),
        fetchAndDeserialize<UserType['regionAvailableCatalogs']>(
            '/cp/user/region_available_catalogs/',
            z.record(z.boolean())
        ),
    ]);

    return {
        ...userData,
        regionAvailableCatalogs,
    };
}
